import { supabaseWorker } from '@/integrations/supabase/workerClient';
import { SearchResult } from './types';
import { calculateRelevance, detectQueryType } from './utils';
import { getDisplayId } from '@/utils/displayId';

export const searchRentals = async (query: string, limit: number): Promise<SearchResult[]> => {
  const queryType = detectQueryType(query);

  type DbRentalPick = {
    id: string;
    public_id: string | null;
    status: string | null;
    start_date: string;
    end_date: string | null;
    total_amount: number | null;
    notes: string | null;
  };

  const baseSelect = () =>
    supabaseWorker
      .from('rentals')
      .select('id, public_id, status, start_date, end_date, total_amount, notes');

  let queries: Array<ReturnType<typeof baseSelect>> = [];

  if (queryType === 'id') {
    queries = [
      baseSelect().eq('id', query).limit(limit),
      baseSelect().ilike('id', `${query}%`).limit(limit),
      baseSelect().ilike('notes', `%${query}%`).limit(limit),
    ];
  } else {
    queries = [
      baseSelect().ilike('notes', `%${query}%`).limit(limit),
    ];
  }

  const results = await Promise.all(
    queries.map(async (q) => {
      const { data, error } = await q;
      if (error) {
        // eslint-disable-next-line no-console
        console.error('[GlobalSearch][rentals] source error:', error);
      }
      return (Array.isArray(data) ? (data as DbRentalPick[]) : []) as DbRentalPick[];
    })
  );
  const rows: DbRentalPick[] = results.flat();
  const unique = Array.from(new Map(rows.map(r => [r.id, r])).values()).slice(0, limit);

  return unique.map(dbRental => {
    const displayId = getDisplayId(dbRental, 6);
    return ({
      id: dbRental.id,
      type: 'rental' as const,
      title: `Аренда ${displayId}`,
      subtitle: 'Аренда',
      description: `Сумма: ${dbRental.total_amount || 0} ₽`,
      icon: 'Calendar',
      url: `/rentals`,
      relevance: calculateRelevance(query, [dbRental.id, dbRental.notes || ''], queryType),
      createdAt: dbRental.start_date,
      status: dbRental.status
    });
  });
};

